import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { ProductionSearchRequest } from '../../../../models/net/request/production-search-request';
import { ProductionSearchResult } from '../../../../models/net/result/production-search-result';
import { Subject, takeUntil } from 'rxjs';
import { AppService } from '../../../../services/app.service';
import { ProductionService } from '../../../../services/productions/production.service';
import { ActionButton } from '../../../../models/app/action-button';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageSeverity } from '../../../../enums/message-severity';
import { MatTableDataSource } from '@angular/material/table';
import { Production } from '../../../../models/data/talent-core/production';
import { DeleteResult } from '../../../../models/net/result/crud/delete-result';
import { SearchComponent } from '../../../base/search/search.component';
import { ProductionStatus } from '../../../../models/data/talent-core/production-status';
import { SearchRequestTypeEnum } from '../../../../enums/search-request-type-enum';
import { SearchMarqueeComponent } from '../../../fragments/search-marquee/search-marquee.component';
import { SearchRequestEnvelope } from '../../../../models/net/envelope/search-request-envelope';
import { SearchPreference } from '../../../../models/data/app-core/search-preference';
import { SessionService } from '../../../../services/session/session.service';

@Component({
    selector: 'app-productions',
    templateUrl: './productions.component.html',
    styleUrls: ['./productions.component.css', '../../../../app.component.css']
})

export class ProductionsComponent extends SearchComponent implements OnInit {

    public displayedColumns: string[] = ["Avatar", "Name", "ProductionStatus", "Delete"];
    public override searchRequest: ProductionSearchRequest = new ProductionSearchRequest();
    public override searchResult: ProductionSearchResult[] = [];
    //public productionStatuses: ProductionStatus[] = [];
    //public productionStatusIds: number[] = [];
    //public searchRequestTypeEnum: SearchRequestTypeEnum = SearchRequestTypeEnum.ProductionSearchRequest;
    public searchRequestTypeName: string = "SearchRequestEnvelope";
    public searchRequestTileComponentTypeName: string = "SearchTileComponent";

    @ViewChild("searchMarquee") searchMarquee!: SearchMarqueeComponent;

    public constructor(public override appService: AppService, public override sessionService: SessionService, public override itemService: ProductionService) {

        super(appService, sessionService, itemService, "production", "Production");
        super.searchRequestTypeEnum = SearchRequestTypeEnum.ProductionSearchRequest;
    }

    public override ngOnInit(): void {

        super.ngOnInit();

        //this.itemService.getProductionStatuses().subscribe((r: ProductionStatus[] | null) => {

        //    if (r != null) {

        //        if (r instanceof HttpErrorResponse) {

        //            this.appService.showDialog(MessageSeverity.Error, "Error Getting Statuses", "An error occurred getting engagement statuses", "OK", "", true, true);

        //        } else {

        //            this.productionStatuses = r;
        //        }
        //    }
        //});
    }

    public ngAfterViewInit(): void {

        this.searchMarquee!.runSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            const searchRequest: ProductionSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            this.runSearch(searchRequest);
        });

        this.searchMarquee!.runSavedSearch.subscribe((searchRequestEnvelope: SearchRequestEnvelope) => {

            var searchRequest: ProductionSearchRequest = JSON.parse(searchRequestEnvelope!.Document!.Item.SearchRequestJson);

            if (searchRequest) {

                this.runSearch(searchRequest);
            }
        });
    }

    public override handleSearchPreference(searchPreference: SearchPreference): void {

        if (searchPreference.SearchPreferenceId > 0) {

            if (searchPreference.DefaultSearchRequestId) {

                this.searchMarquee!.isSavedSearchMode = true;

                this.searchMarquee!.setDefaultSearchRequestId(searchPreference.DefaultSearchRequestId);

                if (searchPreference.IsRunDefaultSearchOnLoad) {

                    this.searchMarquee!.searchRequested();
                }
            }

        } else {

            this.searchMarquee!.isSavedSearchMode = false;
        }

        this.isSearchMarqueeDisabled = false;
    }

    public override getItemIndexFromSearchResult = (id: number): number | undefined => {

        const result = this.searchResult.map((i: ProductionSearchResult) => i.ProductionId).indexOf(id, 0);

        return result;
    }

    public runSearch = (searchRequest: ProductionSearchRequest): void => {

        this.searchRequest = searchRequest;

        this.search();
    }
}
